import { useState } from "react";
import { FiSearch } from "react-icons/fi";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import SplitPane from "react-split-pane";
import PinGenerator from "./PinGenerator";
import PasswordChecker from "./PasswordChecker";
import PasswordGenerator from "./PasswordGenerator";
import { CgLoadbarDoc } from "react-icons/cg";
import { RiLockPasswordLine } from "react-icons/ri";
import { GoGear, GoShieldCheck } from "react-icons/go";
import { TbNumber123 } from "react-icons/tb";
import NoDataHere from "../../Img/nodatahere.png"
import PinCombination from "./PinCombination";
import PasswordCombination from "./PasswordCombination";
import ActivityTimeline from "../ActivityTimeline";
import { FaHistory } from "react-icons/fa";

const ToolManagement = ({ isDark }) => {
  const [tool, setTool] = useState("");
  const [searchData, setSearchData] = useState("");
  const toolsList = [
    {
      key: "pinGenerator",
      title: "Pin Generator",
      description:
        "This PIN Generator quickly generates safe and reliable PINs to enhance security and user verification.",
      icon: <TbNumber123 style={{ fontSize: 15 }} />
    },
    {
      key: "passwordGenerator",
      title: "Password Generator",
      description:
        "This password generator helps you generate strong and reliable passwords instantly for better security.",
      icon: <RiLockPasswordLine style={{ fontSize: 15 }} />
    },
    {
      key: "passwordChecker",
      title: "Password Checker",
      description:
        "This password checker analyzes your password and indicates how strong and secure it is.",
      icon: <GoShieldCheck style={{ fontSize: 15 }} />
    },
    {
      key: "pinCombination",
      title: "Pin Combination",
      description:
        "This pin combination analyzes your password and indicates how strong and secure it is.",
      icon: <GoShieldCheck style={{ fontSize: 15 }} />
    },
    {
      key: "passwordCombination",
      title: "Password Combination",
      description:
        "This password combination analyzes your password and indicates how strong and secure it is.",
      icon: <GoShieldCheck style={{ fontSize: 15 }} />
    }
  ];

  const filteredList = toolsList.filter(item =>
    searchData.trim() === ""
      ? true
      : item.title.toLowerCase().includes(searchData.toLowerCase())
  );

  const activities = [
    {
      id: 1,
      time: "09:30 AM",
      title: "686965",
      type: "success",
    },
    {
      id: 2,
      time: "10:15 AM",
      title: "4556",
      type: "success",
    },
    {
      id: 3,
      time: "11:05 AM",
      title: "25",
      type: "success",
    },
    {
      id: 3,
      time: "11:05 AM",
      title: "4564",
      type: "success",
    },
    {
      id: 3,
      time: "11:05 AM",
      title: "4534",
      type: "success",
    },
    {
      id: 3,
      time: "11:05 AM",
      title: "7867",
      type: "success",
    },
  ];

  return (
    <div className="position-relative">
      <div className="p-2 hstack gap-2 border-bottom">
        <div className="position-relative w-100">
          <Form.Control onChange={(e) => setSearchData(e.target.value)} value={searchData} type="search" className="interactive-input rounded-1 py-2 ps-5" title="Search Tools..." style={{ fontSize: 12 }} placeholder={`Search Tools...`} />
          <FiSearch className="position-absolute" style={{ top: 11, left: 18 }} />
        </div>
      </div>
      <SplitPane split="vertical" minSize={"25%"} className="position-relative">
        <div style={{ height: "100vh" }}>
          <div className="p-2 hstack justify-content-between gap-2">
            <div className="position-relative">
              <Button variant={isDark ? "outline-dark" : "outline-light"} className={`${!isDark ? "text-dark" : "text-white"} py-1 px-2 rounded-1 hstack gap-2`} title="Tools"><GoGear /> <span style={{ fontSize: 14 }}>Tools ({filteredList?.length})</span></Button>
            </div>
          </div>
          <div className="px-2 pb-3 overflow-auto" style={{ height: "calc(100vh - 100px)" }}>
            {filteredList?.length > 0 ? (
              <div className="item-list">
                {filteredList.map((item, index) => (
                  <div
                    key={index}
                    action
                    title={item.title}
                    className={`item-card shadow-sm ${tool === item.key ? "active" : ""}`}
                    onClick={() => setTool(item.key)}
                  >
                    <div>
                      <div className="hstack gap-1">
                        {item.icon}
                        <div className="hstack gap-2 fw-bold" style={{ fontSize: 14 }}>{item.title}</div>
                      </div>

                      <div className="d-flex gap-1" style={{ marginLeft: 1 }}>
                        <CgLoadbarDoc style={{ fontSize: 22, marginRight: 2, marginTop: -4 }} />
                        <div className="hstack gap-2" style={{ fontSize: 11 }}>
                          {item.description}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="item-empty-state">
                There are no items.
              </div>
            )}
          </div>
        </div>
        <div >
          <Container fluid>
            <Row>
              <Form.Group as={Col} md={(activities?.length > 0 && tool) ? 8 : 12} className={`${(activities?.length > 0 && tool) && "border-end"} py-4 overflow-auto`} style={{ height: "calc(100vh - 53px)" }}>
                <div className={!(activities?.length > 0 && tool) && "w-50 m-auto"}>
                  {tool === "pinGenerator" ?
                    <PinGenerator isDark={isDark} />
                    : tool === "passwordGenerator" ?
                      <PasswordGenerator isDark={isDark} />
                      : tool === "passwordChecker" ?
                        <PasswordChecker isDark={isDark} />
                        : tool === "pinCombination" ?
                          <PinCombination isDark={isDark} />
                          : tool === "passwordCombination" ?
                            <PasswordCombination isDark={isDark} />
                            :
                            <span className="small hstack justify-content-center" style={{ height: "calc(100vh - 101px)" }}>
                              <div className="text-center" style={{ pointerEvents: "none", userSelect: "none" }}>
                                <img src={NoDataHere} style={{ width: 200, opacity: .1 }} alt="" />
                                <p className="text-muted">Select any tool.</p>
                              </div>
                            </span>
                  }
                </div>
              </Form.Group>
              {tool &&
                <Form.Group as={Col} md={4} className="p-0">
                  <Form.Label className="fw-bold pt-4 px-4 hstack gap-2"><FaHistory /> History</Form.Label>
                  <div className="overflow-auto ps-4" style={{ height: "calc(100vh - 100px)" }}>
                    <ActivityTimeline activities={activities} />
                  </div>
                </Form.Group>
              }
            </Row>
          </Container>
        </div>
      </SplitPane>
    </div>
  );
};

export default ToolManagement;
